import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, memo } from "react";
import BottomNavItem from "../BottomNavItem";
import StyledBottomNav from "./styles";
import { Box } from "../Box";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import { NotificationDot } from "../NotificationDot";
import { Overlay } from "../Overlay";
var BottomNav = function(_param) {
    var _param_items = _param.items, items = _param_items === void 0 ? [] : _param_items, _param_activeItem = _param.activeItem, activeItem = _param_activeItem === void 0 ? "" : _param_activeItem, _param_activeSubItem = _param.activeSubItem, activeSubItem = _param_activeSubItem === void 0 ? "" : _param_activeSubItem, props = _object_without_properties(_param, [
        "items",
        "activeItem",
        "activeSubItem"
    ]);
    var _useState = _sliced_to_array(useState({}), 2), menuOpenByIndex = _useState[0], setMenuOpenByIndex = _useState[1];
    var isBottomMenuOpen = Object.values(menuOpenByIndex).some(function(acc) {
        return acc;
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isBottomMenuOpen && /*#__PURE__*/ _jsx(Overlay, {}),
            /*#__PURE__*/ _jsx(StyledBottomNav, _object_spread_props(_object_spread({
                justifyContent: "space-around"
            }, props), {
                children: items.map(function(param, index) {
                    var label = param.label, menuItems = param.items, href = param.href, icon = param.icon, fillIcon = param.fillIcon, _param_showOnMobile = param.showOnMobile, showOnMobile = _param_showOnMobile === void 0 ? true : _param_showOnMobile, _param_showItemsOnMobile = param.showItemsOnMobile, showItemsOnMobile = _param_showItemsOnMobile === void 0 ? true : _param_showItemsOnMobile, disabled = param.disabled;
                    var _menuItems_find, _menuItems_find_status;
                    var statusColor = (_menuItems_find = menuItems === null || menuItems === void 0 ? void 0 : menuItems.find(function(menuItem) {
                        return menuItem.status !== undefined;
                    })) === null || _menuItems_find === void 0 ? void 0 : (_menuItems_find_status = _menuItems_find.status) === null || _menuItems_find_status === void 0 ? void 0 : _menuItems_find_status.color;
                    return showOnMobile && /*#__PURE__*/ _jsx(DropdownMenu, {
                        items: menuItems,
                        isBottomNav: true,
                        activeItem: activeSubItem,
                        showItemsOnMobile: showItemsOnMobile,
                        setMenuOpenByIndex: setMenuOpenByIndex,
                        index: index,
                        isDisabled: disabled,
                        children: /*#__PURE__*/ _jsx(Box, {
                            children: /*#__PURE__*/ _jsx(NotificationDot, {
                                show: !!statusColor,
                                color: statusColor,
                                children: /*#__PURE__*/ _jsx(BottomNavItem, {
                                    href: href,
                                    disabled: disabled,
                                    isActive: href === activeItem,
                                    label: label,
                                    icon: icon,
                                    fillIcon: fillIcon,
                                    showItemsOnMobile: showItemsOnMobile
                                })
                            })
                        })
                    }, "".concat(label, "#").concat(href));
                })
            }))
        ]
    });
};
export default /*#__PURE__*/ memo(BottomNav);
